/**
 * Auth constants
 */
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_USER = "UPDATE_USER";

/**
 * Job posts constants
 */
export const GET_POSTS = "GET_POSTS";
export const GET_POSTS_SEARCH = "GET_POSTS_SEARCH";
export const GET_POST_BY_ID = "GET_POST_BY_ID";
export const GET_POST = "GET_POST";
export const CLEAR_POSTS = "CLEAR_POSTS";
export const CLEAR_SEARCH = "CLEAR_SEARCH";
export const ACCEPT_JOB = "ACCEPT_JOB";
export const GET_APPLICATIONS = "GET_APPLICATIONS";
export const GET_APPLICATION_BY_ID = "GET_APPLICATION_BY_ID";
export const CLEAR_APPLICATIONS = "CLEAR_APPLICATIONS";
export const GET_INVITES = "GET_INVITES";
export const GET_INVITE_BY_ID = "GET_INVITE_BY_ID";
export const CLEAR_INVITES = "CLEAR_INVITES";

/**
 * Filter constants
 */
export const SET_FILTER = "SET_FILTER";
export const SET_TEXT_FILTER = "SET_TEXT_FILTER";
export const SET_LOCATION_FILTER = "SET_LOCATION_FILTER";
export const SET_CAT_FILTER = "SET_CAT_FILTER";
export const SET_LEVEL_FILTER = "SET_LEVEL_FILTER";
export const SET_SALARY_FILTER = "SET_SALARY_FILTER";
export const SET_TOOLS = "SET_TOOLS";
export const GET_TALENTS = "GET_TALENTS";
export const CLEAR_FILTER = "CLEAR_FILTER";

/**
 * Student constants
 */
export const SET_STUDENTS = "SET_STUDENTS";
export const SET_STUDENT = "SET_STUDENT";
export const CHANGE_STU_STATUS = "CHANGE_STU_STATUS";
export const TOGGLE_NAVBAR = "TOGGLE_NAVBAR";
export const SET_STUDENT_DETAILS = "SET_STUDENT_DETAILS";

/**
 * Recruiter constants
 */
export const SET_RECRUITER = "SET_RECRUITER";
